import type { IconData } from '@stacksjs/iconify-core'

export const gauge: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M425.706 142.294A240 240 0 0 0 16 312v88h144v-32H48v-56c0-114.691 93.309-208 208-208s208 93.309 208 208v56H352v32h144v-88a238.43 238.43 0 0 0-70.294-169.706\"/><path fill=\"currentColor\" d=\"M80 264h32v32H80zm160-136h32v32h-32zm-104 40h32v32h-32zm264 96h32v32h-32zm-102.778 71.1l69.2-144.173l-28.85-13.848l-69.183 144.135a64.141 64.141 0 1 0 28.833 13.886M256 416a32 32 0 1 1 32-32a32.036 32.036 0 0 1-32 32\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default gauge
